import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import ButtonGroup from './ButtonGroup';
import { FULL_VH } from 'components/Common';
import theme from 'themes';
import { isiOS } from 'config';

const StyledContainer = styled.div`
  color: #000;
  background: white;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 65537;
  ${({ theme }) => theme.Modal}
`;

const HeightContainer = styled.div`
  position: relative;
  height: 100%;
  max-height: ${0.9 * FULL_VH}px;
  display: flex;
  flex-direction: column;
`;

const sectionBorder = '1px solid #edecf2;';

const Above = styled.div`
  ${() => (isiOS ? 'flex: 0 0 auto;' : '')}
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
  margin: 25px 30px;
`;
const AboveString = styled.div`
  margin-top: 20px;
`;

// Center and CenterBox are a trick to
// both constrain the center area in the context of
// the HeightContainer flexbox and allow it to grow up to
// a maximum size. At this point it will scroll.
const Center = styled.div`
  flex-shrink: 1;
  overflow-y: auto;
  border-top: ${sectionBorder};

  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    border: none;
    background-color: rgba(0, 0, 0, 0.25);
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
  }
`;

const CenterBox = styled.div`
  display: flex;
  min-height: min-content;
`;

const Below = styled.div`
  ${() => (isiOS ? 'flex: 0 0 auto;' : '')}
  border-top: ${sectionBorder};
  padding: 20px;
`;

const Title = styled.div`
  color: #030303;
  font: 18px ${({ theme }) => theme.fontSemibold};
  line-height: 24px;
`;

const Content = ({ buttons, contentAbove, contentCenter, title }) => {
  let above, center;
  if (contentAbove) {
    above =
      typeof contentAbove === 'string' ? (
        <AboveString>{contentAbove}</AboveString>
      ) : (
        contentAbove
      );
  }
  if (contentCenter) {
    center = (
      <Center>
        <CenterBox>{contentCenter}</CenterBox>
      </Center>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <StyledContainer>
        <HeightContainer>
          <Above>
            <Title>{title}</Title>
            {above}
          </Above>
          {center}
          <Below>
            <ButtonGroup buttons={buttons} />
          </Below>
        </HeightContainer>
      </StyledContainer>
    </ThemeProvider>
  );
};

Content.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.element.isRequired
      ]),
      onClick: PropTypes.func.isRequired
    })
  ),
  contentAbove: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  contentCenter: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired
};

export default Content;
